import {atom} from 'nanostores';

/**
 * The active span.
 * This is "global" within a tab, thus meaning only ONE active workflow at a time (not simultaneous).
 */
export const $activeSpanId = atom<string | null>(null);

/**
 * Sets the currently active span.
 */
export function setActiveSpanId(id: string): void {
  $activeSpanId.set(id);
}

/**
 * Clears the active span.
 */
export function clearActiveSpanId(): void {
  $activeSpanId.set(null);
}

/**
 * Start a new span. Overwrites any active span (if one exists).
 */
export function startSpan(): string {
  const id = crypto.randomUUID();
  $activeSpanId.set(id);
  return id;
}
